// extracted by mini-css-extract-plugin
module.exports = {"message":"NotFoundPageComponent_message__1ugQi","darkTheme":"NotFoundPageComponent_darkTheme__1DMWx","lighTheme":"NotFoundPageComponent_lighTheme__16Dm1"};